import React from 'react'
import './css/hero.css'
import hand_icon from './assets/hand_icon.png'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import hero_img from './assets/hero_image.png'

const Hero = ({ onScrollToCollection }) => {
    return (
        <div className='hero'>
            <div className="hero-left">
                <h2>New Arrivals Only</h2>
                <div className="hero-hand-icon">
                    <span className='title'>New</span>
                    <img src={hand_icon} alt="" />
                </div>
                <span className='title'>collections</span>
                <span className='title'>for everyone</span>
                <div className="hero-latest-btn" onClick={onScrollToCollection}>
                    <span className='button'>Latest Collection</span>
                    <ArrowForwardIcon />
                </div>
            </div>
            <div className="hero-right">
                <img className='hero-right-img' src={hero_img} alt="" />
            </div>
        </div>
    )
}

export default Hero